import { Table, TableBody, TableHead, TableHeader, TableRow } from 'design-system';

import type { ExtendedSeriesOptionsType } from '@/features/charts/types/highcharts';
import { chartTableCells } from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ChartTab/chartTableCells';
import { cn } from '@/lib/utils';

import LegendItem from './LegendItem';

interface ChartLegendProps {
  series: ExtendedSeriesOptionsType[] | undefined;
}

const ChartLegend = ({ series }: ChartLegendProps) => (
  <div className='pt-2 pb-4'>
    <div className='w-full overflow-hidden rounded-xl border border-border bg-card'>
      <Table aria-label='chart legend table'>
        <TableHeader>
          <TableRow className='bg-gx-tile-dark'>
            {chartTableCells.map((cell, index) => (
              <TableHead
                key={cell.name}
                className={cn(
                  'text-sm text-gx-text-disabled',
                  cell.align === 'right' && 'text-right',
                  index === chartTableCells.length - 1 ? 'pr-0' : 'pr-10'
                )}
              >
                {cell.name}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {series?.map(item => (
            <LegendItem
              key={item.id}
              series={item}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  </div>
);

export default ChartLegend;
